import List from '../components/list.js';
import { useState, useContext, useEffect } from 'react';
import Context from '../components/context.js';
import { AccessContext } from '../components/context.js';
import { Link } from 'react-router-dom';
import axios from 'axios';
import placeholderImage from '../images/placeholder.webp';
import { toast } from 'react-toastify';

const EpisodeTitle = ({img, title}) => {
    return (
        <div className="episode-list-title-container">
            <img src={img.startsWith('http') ? img : process.env.REACT_APP_MEDIA_URL + img} alt={title} />
            <div style={{maxWidth: 250}}>{title}</div>
        </div>
    );
}
const SpeakerComponent = ({speakers}) => {
    return (
        <div className="episode-list-speaker-container">
            {speakers?.length > 0 && Array.isArray(speakers) ? speakers?.map(s => (
                <img src={!s.imageUrl ? placeholderImage : (s.imageUrl.startsWith('http') ? s.imageUrl : process.env.REACT_APP_MEDIA_URL + s.imageUrl)} title={s.firstName + ' ' + s.lastName} alt={s.firstName + ' ' + s.lastName} />
            )) : (
                <span>None</span>
            )}
        </div>
    );
}
const Hosts = ({hosts}) => {
    return <SpeakerComponent speakers={hosts} />
}
const Guests = ({guests}) => {
    return <SpeakerComponent speakers={guests} />
}
const Status = ({status}) => {
    return (
        <div className={"episode-status-container " + status.toLowerCase()}>
            <div className="dot"></div>
            <span>{status}</span>
        </div>
    );
}
const MetricsIcon = ({active}) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.6663 4.66602L8.99967 10.3327L5.66634 6.99935L1.33301 11.3327" stroke="#4A5565" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.667 4.66602H14.667V8.66602" stroke="#4A5565" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
}
const Metrics = ({active}) => {
    return (
        <div>
            Sample Metrics
        </div>
    );
}

const formatDurationString = (n) => {
    const seconds = n % 60;
    const minutesTotal = (n / 60) | 0;
    const minutes = minutesTotal % 60;
    const hours = (minutesTotal / 60) | 0;
    if (hours > 0)
        return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

const EpisodeList = () => {
    const [episodes, setEpisodes] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const setContext = useContext(Context)[1];
    const { role, metaData, isHosted, podcastMetaData } = useContext(AccessContext);
    const [checks, setChecks] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [filter, setFilter] = useState(0);
    setContext('Episodes');
    var headings = [
        { key: 'id', name: 'ID', hide: true },
        { key: ['img', 'title'], name: 'Episode Title', link: true, linkKey: 'id', Component: EpisodeTitle },
        { key: ['hosts'], name: 'Hosts', Component: Hosts },
        { key: ['guests'], name: 'Guests', Component: Guests },
        { key: ['img'], name: 'Metrics', Component: Metrics, detailsIcon: MetricsIcon, center: true },
        { key: 'duration', name: 'Length', center: true },
        { key: 'airDate', name: 'Date', center: true },
        { key: ['status'], name: 'Status', Component: Status }
    ]
    if (role == 'Host/Guest') {
        headings = [
            { key: 'id', name: 'ID', hide: true },
            { key: ['img', 'title'], name: 'Episode Title', link: true, linkKey: 'id', Component: EpisodeTitle },
            { key: ['hosts'], name: 'Hosts', Component: Hosts },
            { key: ['guests'], name: 'Guests', Component: Guests },
            { key: ['img'], name: 'Metrics', Component: Metrics, detailsIcon: MetricsIcon, center: true },
            { key: 'duration', name: 'Length', center: true },
            { key: 'airDate', name: 'Date', center: true },
            { key: ['status'], name: 'Status', Component: Status }
        ];
    }
    const loadEpisodes = (page) => {
        setLoading(true);
        if (role == "Host/Guest") {
            axios.post(process.env.REACT_APP_API_URL + 'speaker/episodes', {
                speakerId: metaData.speakerId,
                page: page,
                search: search,
                filter: filter
            }).then(r => {
                setLoading(false);
                if (r?.data?.status === 'Success') {
                    var now = new Date();
                    var filtered = r.data.results.map(res => {
                        return {
                            id: res.id,
                            img: res.imageUrl.startsWith('http') ? res.imageUrl : process.env.REACT_APP_MEDIA_URL + res.imageUrl,
                            title: res.title,
                            hosts: res.hosts,
                            guests: res.guests,
                            duration: formatDurationString(res.duration),
                            airDate: !!res.airDate ? (new Date(res.airDate)).toLocaleDateString() : 'N/A',
                            status: !res.airDate ? 'Draft' : ((new Date(res.airDate)) > now ? 'Scheduled' : 'Published')
                        }
                    }).filter(a => {
                        return a.title.includes(search);
                    });
                    setTotalRecords(r.data.total);
                    setEpisodes(filtered);
                }
            });
            return;
        }
        axios.post(process.env.REACT_APP_API_URL + 'episode', {
            page: page,
            search: search,
            filter: filter
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                setTotalRecords(r.data.total);
                const now = new Date()
                setEpisodes(r.data.results.map(res => {
                    return {
                        id: res.id,
                        img: res.imageUrl.startsWith('http') ? res.imageUrl : process.env.REACT_APP_MEDIA_URL + res.imageUrl,
                        title: res.title,
                        hosts: res.hosts,
                        guests: res.guests,
                        duration: formatDurationString(res.duration),
                        airDate: !!res.airDate ? (new Date(res.airDate)).toLocaleDateString() : 'N/A',
                        status: !res.airDate ? 'Draft' : ((new Date(res.airDate)) > now ? 'Scheduled' : 'Published')
                    }
                }));
            }
        });
    }
    const [isPullingRss, setIsPullingRss] = useState(false);
    const rssPull = () => {
        if (!podcastMetaData.rssFeedUrl) {
            return;
        }
        if (isPullingRss) {
            return;
        }
        setIsPullingRss(true);
        axios.post(process.env.REACT_APP_API_URL + 'rss/pull', {
            rssFeedUrl: podcastMetaData.rssFeedUrl,
            rssLastModified: podcastMetaData.rssLastModified
        }).then(r => {
            if (r?.data?.status === 'Success') {
                toast.success('Episodes updated from RSS feed.');
                setEpisodes([]);
                loadEpisodes(0);
                setCurrentPage(0);
            }
            setIsPullingRss(false);
        }).catch(err => setIsPullingRss(false))
    }
    useEffect(() => {
        setEpisodes([]);
        setCurrentPage(0);
        loadEpisodes(0);
    }, [filter]);
    const deleteEpisodes = () => {
        let toDelete = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.ids.push(episodes[i].id);
                acc.urls.push(...(episodes[i].images?.map?.(img => img.imageUrl) || []));
            }
            return acc
        }, { ids: [], urls: [] });
        if (toDelete.ids.length === 0)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'episode/delete', {
            ids: JSON.stringify(toDelete.ids),
            urls: JSON.stringify(toDelete.urls)
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                loadEpisodes(currentPage);
                setChecks(Array.apply(null, Array(episodes?.length)).map(() => false));
            }
        });
    }
    useEffect(() => {
        loadEpisodes(0);
    }, [role]);
    useEffect(() => {
        setChecks(Array.apply(null, Array(episodes?.length)).map(() => false));
    }, [episodes]);
    const pageSize = 10;
    var pages = [];
    for (var i = Math.max(0, currentPage - 3); i < Math.min(currentPage + 4, Math.ceil(totalRecords / pageSize)); i++) {
        pages.push(i);
    }
    return (
        <main>
            <div className="container w-100">
                <div className="form mb-15 gap-0">
                    <div className="flex f-row f-between a-center f-wrap">
                        <div style={{display: 'block', flexGrow: 0}}>
                            <h1 className="page-title">Episodes</h1>
                            <h2 className="page-subtitle">Manage your podcast episodes and content.</h2>
                        </div>
                        <div className="flex f-end f-row a-center list-top-buttons" style={{gap: 8, flexGrow: 0}}>
                            <div className="status-filters sm-hidden">
                                {!isHosted ? (
                                    <>
                                        <div className="status-filter" onClick={() => setFilter(0)}>
                                            <input id="filter-all" type="radio" checked={filter == 0} />
                                            <label htmlFor="filter-all">All</label>
                                        </div>
                                        <div className="status-filter" onClick={() => setFilter(1)}>
                                            <input id="filter-draft" type="radio" checked={filter == 1} />
                                            <label htmlFor="filter-draft">Draft</label>
                                        </div>
                                        <div className="status-filter" onClick={() => setFilter(3)}>
                                            <input id="filter-sched" type="radio" checked={filter == 3} />
                                            <label htmlFor="filter-sched">Scheduled</label>
                                        </div>
                                        <div className="status-filter" onClick={() => setFilter(2)}>
                                            <input id="filter-pub" type="radio" checked={filter == 2} />
                                            <label htmlFor="filter-pub">Published</label>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="status-filter">
                                            <input id="filter-all" type="radio" checked={true} />
                                            <label htmlFor="filter-all">All Published</label>
                                        </div>
                                        <button className="btn ml-10 flex f-row g-5" onClick={() => { rssPull()}}>
                                            <svg width="16" className={isPullingRss ? 'spinning' : ''} height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.67737 2.00631 11.2874 2.66082 12.4933 3.82667L14 5.33333" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M13.9993 2V5.33333H10.666" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M14 8C14 9.5913 13.3679 11.1174 12.2426 12.2426C11.1174 13.3679 9.5913 14 8 14C6.32263 13.9937 4.71265 13.3392 3.50667 12.1733L2 10.6667" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M5.33333 10.6666H2V14" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            {isPullingRss ? <span>Updating</span> : <span>Update Episodes</span>}
                                        </button>
                                    </>
                                )}
                            </div>
                            {role != "Host/Guest" && !isHosted && (
                                <Link to="/episode" className="btn flex a-center f-row xs-w-100 add-button" style={{gap: 8}}>
                                    <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.5 6H9.5" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M6 2.5V9.5" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <span>Add Episode</span>
                                </Link>
                            )}
                        </div>
                    </div>
                    <div className="content-box w-100">
                        <div className="content-body" style={{padding: 17}}>
                            <div className="input-with-icon">
                                <svg role="button" style={{cursor: 'pointer', pointerEvents: 'all'}} onClick={() => { setEpisodes([]); setCurrentPage(0); loadEpisodes(0) }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#99A1AF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M14.0005 13.9995L11.1338 11.1328" stroke="#99A1AF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <input type="search" aria-label="Search Episodes" placeholder="Search episodes, hosts, guests..." value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => {
                                    if (e.code.toLowerCase() == 'enter') {
                                        setEpisodes([]);
                                        setCurrentPage(0);
                                        loadEpisodes(0);
                                    }
                                 }} />
                            </div>
                        </div>
                    </div>
                    <div className="status-filters sm-visible">
                        {!isHosted ? (
                            <>
                                <div className="status-filter" onClick={() => setFilter(0)}>
                                    <input id="filter-all" type="radio" checked={filter == 0} />
                                    <label htmlFor="filter-all">All</label>
                                </div>
                                <div className="status-filter" onClick={() => setFilter(1)}>
                                    <input id="filter-draft" type="radio" checked={filter == 1} />
                                    <label htmlFor="filter-draft">Draft</label>
                                </div>
                                <div className="status-filter" onClick={() => setFilter(3)}>
                                    <input id="filter-sched" type="radio" checked={filter == 3} />
                                    <label htmlFor="filter-sched">Scheduled</label>
                                </div>
                                <div className="status-filter" onClick={() => setFilter(2)}>
                                    <input id="filter-pub" type="radio" checked={filter == 2} />
                                    <label htmlFor="filter-pub">Published</label>
                                </div>
                            </>
                        ) : (
                            <div className="status-filter">
                                <input id="filter-all" type="radio" checked={true} />
                                <label htmlFor="filter-all">All Published</label>
                            </div>
                        )}
                    </div>
                </div>
                <List list={episodes} href="episode" headings={headings} loading={loading} checkBoxes={false} onCheck={setChecks} footerContent={
                    <div className="flex f-row w-100 a-center f-between">
                        <div className="showing-pages">
                            Showing <b>{episodes.length}</b> of <b>{totalRecords}</b>
                        </div>
                        <div className="list-arrows mt-0">
                            <button className="btn-arrow" disabled={currentPage <= 0} onClick={() => {
                                if (currentPage <= 0)
                                    return;
                                loadEpisodes(currentPage - 1);
                                setCurrentPage(c => c - 1);
                            }}>Prev</button>
                            {pages.map(p => (
                                <button key={p} className={(p == currentPage ? 'btn current-page' : '')} onClick={() => {
                                    loadEpisodes(p);
                                    setCurrentPage(p);
                                }}>{p + 1}</button>
                            ))}
                            <button className="btn-arrow" disabled={(currentPage + 1) * pageSize >= totalRecords - 1} onClick={() => {
                                if ((currentPage + 1) * pageSize >= totalRecords - 1)
                                    return;
                                loadEpisodes(currentPage + 1);
                                setCurrentPage(c => c + 1);
                            }}>Next</button>
                        </div>
                    </div>
                } actions={role == "Host/Guest" ? undefined : [{
                    text: (e) => {
                        return 'Delete'
                    },
                    action: (e) => {
                        setLoading(true);
                        var imgUrls = (episodes.find(ep => ep.id == e.id)?.images?.map?.(img => img.imageUrl) || []);
                        axios.post(process.env.REACT_APP_API_URL + 'episode/delete', {
                            ids: JSON.stringify([e.id]),
                            urls: JSON.stringify(imgUrls)
                        }).then(r => {
                            setLoading(false);
                            if (r?.data?.status === 'Success') {
                                loadEpisodes(currentPage);
                            }
                        });
                    }
                }]} />
            </div>
        </main>
    )
}

export default EpisodeList;